import { useSelector } from 'react-redux'
import { NlpModel, NlpModelId } from '@feedyou-ai/feedbot-schema'

import { nlpModelByIdSelector } from '../../botNlp/selectors'

export function useNlpModelById(modelId: NlpModelId): NlpModel | undefined {
  return useSelector(nlpModelByIdSelector(modelId))
}
